export function promisfyReadFileAsArrayBuffer(blob) {
  return new Promise((res, rej) => {
    const reader = new FileReader();
    reader.onload = e => res(e.target.result);
    reader.onerror = e => rej(e.target.result);
    reader.readAsArrayBuffer(blob);
  });
}

export function validateArrayBufferSha1(arrayBuffer, sha1) {
  const hasher = require("js-sha1");

  const payloadSha1 = hasher(arrayBuffer);

  return payloadSha1 === sha1;
}
